var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubstation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "icon",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M942,534V160h-68v306H701.2c-5.3-31.2-17.6-60-35.4-84.7l97.7-97.7l-48.1-48.1l-97.8,97.8c-24.7-17.5-53.5-29.6-84.6-34.7 V160h-68v139c-30.8,5.4-59.3,17.6-83.7,35.2l-98.7-98.7l-48.1,48.1l98.8,98.8c-17.3,24.4-29.3,52.8-34.5,83.6H58v374h68V534h172.8 c5.2,30.7,17.2,59.1,34.5,83.6l-98.8,98.8l48.1,48.1l98.7-98.7c24.4,17.6,52.9,29.8,83.7,35.2v139h68V701.3 c31.1-5.1,59.8-17.2,84.6-34.7l97.8,97.8l48.1-48.1l-97.7-97.7c17.7-24.7,30.1-53.5,35.4-84.7H942z M500,636c-75,0-136-61-136-136 s61-136,136-136s136,61,136,136S575,636,500,636z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubstation);
export default __webpack_public_path__ + "static/media/substation.59f1dee5.svg";
export { ForwardRef as ReactComponent };